import { forwardRef } from "react";

import Icon from "@/components/Icon";
import CanvasSVG from "./CanvasSVG.svg.jsx";

const CanvasIcon = forwardRef((props, ref) => {
  return (
    // Forces the `viewBox` attribute to be added to the markup
    <Icon {...props} SvgComponent={CanvasSVG} viewBox="0 0 84 85" ref={ref} />
  );
});

export default CanvasIcon;
